<template>
  <div class="subflow">
    <TheSellCarForm
      v-if="showForm" 
      :car="car"
      @success="onSubmitCarForm"
    />
  </div>
</template>
<script>
import TheSellCarForm from './SellCarForm/TheSellCarForm'

export default {
  name: 'VCarForm',

  components: {
    TheSellCarForm,
  },

  props: {
    car: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    showForm: false,
  }),

  watch: {
    show(v) {
      if (!v) {
        setTimeout(() => {
          this.showForm = v
        }, 500)
      } else {
        this.showForm = v
      }
    }
  },

  methods: {
    onSubmitCarForm() {
      this.showModalAndClose()
    },

    showModalAndClose() {
      const modalSuccess = {
        title: 'Updated successfully',
        body: `Car <strong>${this.car.title}</strong> was updated`
      }
      this.$modals.open(modalSuccess)

      setTimeout(() => {
        this.$modals.close()
      }, 3000)
    },
  }
}
</script>
